var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
import { ZonedDate, toLocalDate } from '@progress/kendo-date-math';
/**
 * @hidden
 */
var ZonedDateTimeVue2 = {
  name: 'KendoZonedDateTime',
  // @ts-ignore
  emits: {
    change: null
  },
  props: __assign(__assign({}, DateTimePicker.props), {
    value: [String, Date],
    isAllDay: Boolean,
    as: [String, Function, Object]
  }),
  inject: {
    ks: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      Component = _a.as,
      other = __rest(_a, ["as"]);
    var timezone = this.ks.timezone;
    var dtpProps = __assign(__assign({}, other), {
      format: this.isAllDay ? 'd' : 'g',
      value: this.readDateAsLocal(other.value, timezone)
    });
    var NeededPicker = this.isAllDay ? DatePicker : DateTimePicker;
    var dtp = h(NeededPicker, __assign({
      onChange: this.handleChange,
      on: this.v3 ? undefined : {
        'change': this.handleChange
      },
      attrs: this.v3 ? undefined : dtpProps
    }, dtpProps));
    return dtp;
  },
  methods: {
    handleChange: function handleChange(event) {
      this.$emit('change', {
        value: this.readDateWithTimezone(event.target.value, this.ks.timezone)
      });
    },
    readDateAsLocal: function readDateAsLocal(value, timezone) {
      if (value) {
        return toLocalDate(ZonedDate.fromLocalDate(value, timezone).toUTCDate());
      }
      return value;
    },
    readDateWithTimezone: function readDateWithTimezone(value, timezone) {
      if (value) {
        return ZonedDate.fromUTCDate(new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())), timezone).toLocalDate();
      }
      return value;
    }
  }
};
/**
 * @hidden
 */
var ZonedDateTime = ZonedDateTimeVue2;
export { ZonedDateTime, ZonedDateTimeVue2 };